export default {"src":"/_next/static/media/burger.1796d549.svg","height":11,"width":14};